module.exports = __webpack_public_path__ + "i.no1.20ad6e05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/i.no1.jpg
// module id = duE1
// module chunks = 0